import HeroSection from "./HeroSection";
import OfferingsSection from "./OfferingsSection";
import LookoutSection from "./LookoutSection";
import MustVisitSection from "./MustVisitSection";
import TestimonialsSection from "./TestimonialsSection";
import FaqSection from "./FaqSection";
import AboutHeroSection from "./AboutHeroSection";
import TimelineSection from "./TimelineSection";
import InterestSection from "./InterestSection";
import FrameSliderSection from "./FrameSliderSection";
import ContactSection from "./ContactSection";
import EventHeroSection from "./EventHeroSection";
import EventWrapperSection from "./EventWrapperSection";
import EnquirySection from "./EnquirySection";
import VisitSection from "./VisitSection";
import InfoSection from "./InfoSection";
import AudioTourHeroSection from "./AudioTourHeroSection";
import AudioGridSection from "./AudioGridSection";
import SimpleBannerSection from "./SimpleBannerSection";
import TwoColumnFaqSection from "./TwoColumnFaqSection";
import EarlyClosures from "./EarlyClosures";

const layoutRegistry = {
    hero: HeroSection,
    offerings: OfferingsSection,
    section_lookout: LookoutSection,
    must_visit: MustVisitSection,
    t_section: TestimonialsSection,
    faq: FaqSection,
    about_hero: AboutHeroSection,
    timeline_section: TimelineSection,
    interest_section: InterestSection,
    social: FrameSliderSection,
    contact_section: ContactSection,
    event_hero: EventHeroSection,
    event_wrapper: EventWrapperSection,
    enquiry_section: EnquirySection,
    // visit_section: VisitSection,
    visit_section_title: VisitSection,
    visit_section_map: VisitSection,
    info_section: InfoSection,
    audio_tour_hero: AudioTourHeroSection,
    audio_grid: AudioGridSection,
    simple_banner: SimpleBannerSection,
    two_column_faq: TwoColumnFaqSection,
    alert_timings: EarlyClosures,
};

export default layoutRegistry;

